import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowRight } from 'lucide-react';
interface Slide4Props {
  onNext: () => void;
  onBack: () => void;
}
export function Slide4({
  onNext,
  onBack
}: Slide4Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 1,
    total: 3
  }} onBack={onBack} data-id="element-134">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-5 gap-8 items-center" data-id="element-135">
        <div className="col-span-3 space-y-3" data-id="element-136">
          <h1 className="text-2xl font-bold text-primary mb-2" data-id="element-137">
            One antibody. Two targets.
          </h1>
          <div className="space-y-3" data-id="element-138">
            <p className="text-base text-gray-700 leading-snug" data-id="element-139">
              Faricimab is a bispecific antibody designed to bind and
              neutralise:<sup data-id="element-140">¹</sup>
            </p>
            <ul className="space-y-1 text-base text-gray-700 pl-6" data-id="element-141">
              <li className="flex items-start" data-id="element-142">
                <span className="text-accent mr-3" data-id="element-143">•</span>
                <span data-id="element-144">VEGF-A</span>
              </li>
              <li className="flex items-start" data-id="element-145">
                <span className="text-accent mr-3" data-id="element-146">•</span>
                <span data-id="element-147">Angiopoietin-2 (Ang-2)</span>
              </li>
            </ul>
            <p className="text-base text-gray-700 leading-snug pt-2" data-id="element-148">
              Ang-2 and VEGF-A act synergistically to increase:<sup data-id="element-149">¹</sup>
            </p>
            <ul className="space-y-1 text-base text-gray-700 pl-6" data-id="element-150">
              <li className="flex items-start" data-id="element-151">
                <span className="text-accent mr-3" data-id="element-152">•</span>
                <span data-id="element-153">Vascular permeability</span>
              </li>
              <li className="flex items-start" data-id="element-154">
                <span className="text-accent mr-3" data-id="element-155">•</span>
                <span data-id="element-156">Inflammation</span>
              </li>
              <li className="flex items-start" data-id="element-157">
                <span className="text-accent mr-3" data-id="element-158">•</span>
                <span data-id="element-159">Pathological angiogenesis</span>
              </li>
            </ul>
            <p className="text-sm text-gray-600 leading-snug pt-1 italic" data-id="element-160">
              Targeting both pathways addresses mechanisms contributing to
              vascular instability.
            </p>
          </div>
          <div className="pt-2" data-id="element-161">
            <Button variant="primary" onClick={onNext} data-id="element-162">
              See how it works
              <ArrowRight className="w-5 h-5" data-id="element-163" />
            </Button>
          </div>
        </div>
        <div className="col-span-2 flex items-center justify-center" data-id="element-164">
          <div className="relative w-full h-96" data-id="element-165">
            <div className="absolute inset-0 flex flex-col items-center justify-center space-y-8" data-id="element-166">
              <div className="flex items-center gap-8" data-id="element-167">
                <div className="flex flex-col items-center" data-id="element-168">
                  <div className="w-20 h-20 rounded-full bg-accent text-white flex items-center justify-center font-bold text-sm" data-id="element-169">
                    VEGF-A
                  </div>
                  <div className="mt-4 text-center" data-id="element-170">
                    <div className="w-1 h-16 bg-accent mx-auto" data-id="element-171"></div>
                  </div>
                </div>
                <div className="flex flex-col items-center" data-id="element-172">
                  <div className="w-20 h-20 rounded-full bg-accent text-white flex items-center justify-center font-bold text-sm" data-id="element-173">
                    Ang-2
                  </div>
                  <div className="mt-4 text-center" data-id="element-174">
                    <div className="w-1 h-16 bg-accent mx-auto" data-id="element-175"></div>
                  </div>
                </div>
              </div>
              <div className="w-48 h-24 bg-primary rounded-lg flex items-center justify-center text-white font-bold text-center shadow-xl" data-id="element-176">
                Vascular
                <br data-id="element-177" />
                Instability
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border-4 border-highlight rounded-full flex items-center justify-center bg-white shadow-lg z-10" data-id="element-178">
                <span className="text-primary font-bold text-center text-sm" data-id="element-179">
                  Single
                  <br data-id="element-180" />
                  Antibody
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}